const FOCUSABLE_SELECTOR = [
  "a[href]",
  "button",
  "input:not([type='hidden'])",
  "select",
  "textarea",
  "[tabindex]",
  "[contenteditable='true']",
].join(",");

const isTabbable = (element: HTMLElement) =>
  element.tabIndex >= 0 && !element.hasAttribute("disabled") && !element.closest("[hidden],[inert]");

/**
 * Finds the element that Tab would move to after `from`, in document order.
 * Used where focus has to be moved by hand, e.g. leaving a portalled popover.
 *
 * @param from - Element to start after; its own descendants are skipped
 * @param container - Where to search (defaults to the whole document)
 * @returns The next tabbable element, or undefined if there is none
 */
export const getNextTabbable = (from: HTMLElement, container: ParentNode = document) =>
  Array.from(container.querySelectorAll<HTMLElement>(FOCUSABLE_SELECTOR)).find(
    (element) =>
      Boolean(from.compareDocumentPosition(element) & Node.DOCUMENT_POSITION_FOLLOWING) &&
      !from.contains(element) &&
      isTabbable(element),
  );
